import { toPng } from "html-to-image";
import { jsPDF } from "jspdf";

interface ExportOptions {
  filename: string;
}

export async function exportElementToPdf(element: HTMLElement | null, options: ExportOptions): Promise<void> {
  if (!element) return;

  const dataUrl = await toPng(element, {
    cacheBust: true,
    pixelRatio: 2,
    filter: (node) => {
      if (!(node instanceof HTMLElement)) return true;
      return node.dataset.exportIgnore !== "true";
    }
  });

  const img = new Image();
  const imageLoaded = new Promise<void>((resolve, reject) => {
    img.onload = () => resolve();
    img.onerror = () => reject(new Error("Failed to load export image"));
  });
  img.src = dataUrl;
  await imageLoaded;

  const pdf = new jsPDF({
    orientation: img.width > img.height ? "landscape" : "portrait",
    unit: "pt",
    format: "a4"
  });

  const pageWidth = pdf.internal.pageSize.getWidth();
  const pageHeight = pdf.internal.pageSize.getHeight();
  const ratio = Math.min(pageWidth / img.width, pageHeight / img.height);
  const renderWidth = img.width * ratio;
  const renderHeight = img.height * ratio;
  const offsetX = (pageWidth - renderWidth) / 2;
  const offsetY = (pageHeight - renderHeight) / 2;

  pdf.addImage(dataUrl, "PNG", offsetX, offsetY, renderWidth, renderHeight);
  pdf.save(options.filename);
}
